var filePickeri18n = {
  clear: 'Clear',
  upload: 'Upload'
};
export default filePickeri18n;